// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"7230e9e7","484":"0eeda712"}[chunkId] + ".chunk.css";
};